import { render, staticRenderFns } from "./AdminCreatorPages.vue?vue&type=template&id=0565af98&"
import script from "./AdminCreatorPages.vue?vue&type=script&lang=js&"
export * from "./AdminCreatorPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports